import {combineReducers} from 'redux';

// import Posts from './Posts';
// import Test from './Test';
import User from './User';
import Portfolio from './Portfolio';

export default combineReducers({
    User,
    Portfolio
});



// WEBPACK FOOTER //
// ./src/Reducers/index.js